import { AppState, ImmutableRecordSet, ReportDataset, TransientReportState } from '@mode/legacy/types-app-state';
import { ReducerTree } from '@mode/legacy/util-domain';
import { ReportActionType } from '~/actions/report-actions';
import { Actions } from '../../actions/index';
import { ReportFilterActionType } from '../../actions/report-filter-actions';
import { ReportRunActionType } from '../../actions/report-run.actions';

export const initialTransientReportState: TransientReportState = {
  datasets: new ImmutableRecordSet<ReportDataset>('id'),
  captureReportRunCreatedAt: null,
};

function datasetsReducer(
  state = initialTransientReportState.datasets,
  action: Actions
): TransientReportState['datasets'] {
  switch (action.type) {
    case ReportFilterActionType.FilterReportDatasetsSuccess:
      return state.mergeRecords(action.payload);
    case ReportFilterActionType.FilterReportDatasetSuccess:
      return state.mergeRecord(action.payload);
    case ReportFilterActionType.FilterReportDatasetFailure: // falls through
    case ReportFilterActionType.FilterReportDatasetsFailure:
      console.warn(action.error);
      break;
    case ReportRunActionType.PollReportRun: // For fullscreen refresh
      return state.clear();
    case ReportRunActionType.ExecuteReportRun:
      if (action.runningQueryToken) {
        return state.removeRecordByKey(action.runningQueryToken);
      } else {
        return state.clear();
      }
  }

  return state;
}

function captureRunCreatedAtReducer(
  state = initialTransientReportState.captureReportRunCreatedAt,
  action: Actions
): TransientReportState['captureReportRunCreatedAt'] {
  switch (action.type) {
    case ReportActionType.SetReportCaptureRunCreatedTime:
      return action.createdAt;
  }

  return state;
}

export const TransientReportReducer: ReducerTree<AppState, TransientReportState, Actions> = {
  datasets: datasetsReducer,
  captureReportRunCreatedAt: captureRunCreatedAtReducer,
};
